define('app/sf/min/sf-min-filter',["factory!sf-aggregate-filter"], function (AggregateFilter) {
	return new AggregateFilter(function min(values) {
		return values.reduce(function (previousValue, currentValue, i) {
			if (!i) {
				return currentValue;
			}
			else {
				return currentValue < previousValue ? currentValue : previousValue;
			}
		});
	});
});
